
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/room/[roomId]",
      function () {
        return require("private-next-pages/room/[roomId]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/room/[roomId]"])
      });
    }
  